export default __webpack_public_path__ + "static/5-b31553f92ecb7ccb85386c7e0775294d.png";